import * as React from 'react';
import { observer } from 'mobx-react';
import './subscriptionSuspensionInfoPage.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { SubscriptionSuspensionCreatePageState } from './states/SubscriptionSuspensionCreatePageState';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../routes';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { NotFoundPage } from '../../../mainv2/containers/common/NotFoundPage';
import { CardSelectInput } from '../../../commonv3/components/atoms/forms/card/CardInput';
import { SurveyHeader } from '../../components/molecules/surveys/SurveyHeader';
import { SurveyBody } from '../../components/molecules/surveys/SurveyBody';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { Page, PageBody } from '../../../commonv3/components/atoms/pages/page';
import { QuestionCard } from '../surveys/QuestionCard';
import { QuestionErrorPane } from '../surveys/SurveyShowPage';

type Props = {
    match: {
        params: {
            subscriptionCode: string;
        };
    };
};

@withNavigation(NavigationSpecs.none())
@observer
export class SubscriptionSuspensionCreatePage extends React.Component<Props> {
    pageState = new SubscriptionSuspensionCreatePageState();

    componentDidMount() {
        const { subscriptionCode } = this.props.match.params;
        this.pageState.init(subscriptionCode);
    }

    render() {
        const SUSPENSION_FORM_COUNT = 2;
        const { subscription: subscriptionResource, formState, submitState, surveyState } = this.pageState;
        const { initialized, parameterParseError, questions, getQuestionStateFor } = this.pageState.surveyState;
        if (!this.pageState.initialized || !initialized) {
            return <LoaderRow />;
        }
        if (subscriptionResource.isNotFound() || parameterParseError) {
            return <NotFoundPage entityType="Subscription" />;
        }
        if (subscriptionResource.isError()) {
            GlobalStatesV3.routing.push(V3Routes.home());
            return null;
        }
        const { starts_at, duration } = formState.fields;
        const totalFormCount = questions.length + SUSPENSION_FORM_COUNT;
        return (
            <Page styleName="page-gray" id="subscription-suspension-create-page">
                <PageBody>
                    <SurveyHeader surveyName="休会フォーム" />
                    <SurveyBody>
                        <CardSelectInput
                            id="starts_at"
                            questionNumber={1}
                            totalQuestions={totalFormCount}
                            required={true}
                            sentence="休会開始日を教えてください"
                            options={this.pageState.startsAtOptions}
                            state={starts_at}
                            serializer={(v) => v}
                            deserializer={(v) => v}
                        />
                        <CardSelectInput
                            id={'duration'}
                            questionNumber={2}
                            totalQuestions={totalFormCount}
                            required={true}
                            sentence="休会期間を選択してください"
                            subSentence="※休会期間内でも復帰することは可能です "
                            options={this.pageState.durationOptions}
                            state={duration}
                            serializer={(v) => v}
                            deserializer={(v) => v}
                        />
                        {questions.map((q, index) => {
                            const questionState = getQuestionStateFor(q.survey_question_id);
                            const questionNumber = index + 1 + SUSPENSION_FORM_COUNT;
                            const totalQuestionsCount = questions.length + SUSPENSION_FORM_COUNT;
                            return (
                                <QuestionCard
                                    key={q.survey_question.id}
                                    questionNumber={questionNumber}
                                    totalQuestions={totalQuestionsCount}
                                    question={q.survey_question}
                                    questionState={questionState}
                                />
                            );
                        })}
                        {surveyState.hasErrors && (
                            <QuestionErrorPane
                                errorQuestions={surveyState.errorQuestions}
                                questionIndexOffset={SUSPENSION_FORM_COUNT}
                            />
                        )}
                        <Button
                            id="submit-button"
                            styleName="submit-button"
                            type="primary"
                            size="l"
                            disabled={!formState.isValid}
                            loading={submitState.submitting}
                            onClick={() => this.pageState.submit()}
                        >
                            休会する
                        </Button>
                    </SurveyBody>
                </PageBody>
            </Page>
        );
    }
}
